/*
 * Copyright (c) 2023 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ErrorHandlingService } from './error-handling.service';
import { AuthenticationService } from '../core/authentication/authentication.service';

/** For generic app-wide errors. */
@Injectable()
export class ExceptionInterceptService implements HttpInterceptor {

  constructor(private readonly errorHandlingService: ErrorHandlingService, private readonly authService: AuthenticationService) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
   if (req.headers.get('skip')) {
      return next.handle(req);
    }
    return next.handle(req.clone({ setHeaders: { Authorization: this.authService.getAuthorizationHeaderValue()}})).pipe(
      catchError((error: HttpErrorResponse) => {
        return this.errorHandlingService.handleError(error);
      }));
  }
}
